export default {
  en: {
    contactPerson: 'Contact Person',
    save: 'Save',
    cancel: 'Cancel',
    selectedVersion: 'Selected versions',
    latestVersion: 'Latest versions',
    updatedContactPersonMessage: 'This contact person has been updated',
    deletedContactPersonMessage: 'This contact person has been deleted'
  },
  th: {
    contactPerson: 'ผู้ติดต่อ',
    save: 'บันทึก',
    cancel: 'ยกเลิก',
    selectedVersion: 'ข้อมูลที่เลือก',
    latestVersion: 'ข้อมูลล่าสุด',
    updatedContactPersonMessage: 'ผู้ติดต่อคนนี้มีการแก้ไข',
    deletedContactPersonMessage: 'ผู้ติดต่อคนนี้ถูกลบไปแล้ว'
  }
}
